document.documentElement.classList.remove('no-js');

document.querySelectorAll('[data-variant-select]').forEach((select) => {
  const root = select.closest('[data-product-root]');
  const price = root && root.querySelector('[data-product-price]');
  select.addEventListener('change', () => {
    const option = select.options[select.selectedIndex];
    if (price && option) price.textContent = option.dataset.price || price.textContent;
  });
});

const dispatchTBJAnalytics = (eventName, payload = {}, callback) => {
  if (typeof window.TBJTrackEvent === 'function') {
    window.TBJTrackEvent(eventName, payload, callback);
    return;
  }
  window.dataLayer = window.dataLayer || [];
  window.dataLayer.push({ event: eventName, tbj_event_source: 'theme_fallback', ...payload });
  if (typeof callback === 'function') window.setTimeout(callback, 250);
};

const setExternalLinks = () => {
  document.querySelectorAll('a[href]').forEach((link) => {
    try {
      const url = new URL(link.href, window.location.href);
      if ((url.protocol === 'http:' || url.protocol === 'https:') && url.origin !== window.location.origin) {
        link.target = '_blank';
        const rel = new Set((link.rel || '').split(/\s+/).filter(Boolean));
        rel.add('noopener');
        rel.add('noreferrer');
        link.rel = Array.from(rel).join(' ');
      }
    } catch (error) {
      return;
    }
  });
};
setExternalLinks();
document.addEventListener('shopify:section:load', setExternalLinks);

const initVideoHubAutoplay = (scope = document) => {
  const frames = scope.querySelectorAll('[data-youtube-autoplay]');
  if (!frames.length || !('IntersectionObserver' in window)) return;

  const sendCommand = (frame, command) => {
    if (!frame.contentWindow) return;
    frame.contentWindow.postMessage(JSON.stringify({ event: 'command', func: command, args: [] }), 'https://www.youtube.com');
  };

  const observer = new IntersectionObserver((entries) => {
    entries.forEach((entry) => {
      const frame = entry.target;
      if (entry.isIntersecting && entry.intersectionRatio >= 0.5) {
        sendCommand(frame, 'mute');
        sendCommand(frame, 'playVideo');
      } else {
        sendCommand(frame, 'pauseVideo');
      }
    });
  }, { threshold: [0, 0.5, 1] });

  frames.forEach((frame) => {
    if (frame.dataset.autoplayObserved === 'true') return;
    frame.dataset.autoplayObserved = 'true';
    observer.observe(frame);
  });
};

initVideoHubAutoplay();
document.addEventListener('shopify:section:load', (event) => initVideoHubAutoplay(event.target));

const initVideoSoundControls = (scope = document) => {
  const controls = scope.querySelectorAll('[data-video-sound-toggle]');
  controls.forEach((control) => {
    if (control.dataset.soundControlReady === 'true') return;
    control.dataset.soundControlReady = 'true';
    const frame = control.closest('[data-video-frame]')?.querySelector('[data-youtube-autoplay]');
    if (!frame) return;
    const label = control.querySelector('[data-video-sound-label]');
    control.addEventListener('click', () => {
      const isSoundOn = control.getAttribute('aria-pressed') === 'true';
      const command = isSoundOn ? 'mute' : 'unMute';
      if (frame.contentWindow) {
        frame.contentWindow.postMessage(JSON.stringify({ event: 'command', func: command, args: [] }), 'https://www.youtube.com');
        if (!isSoundOn) frame.contentWindow.postMessage(JSON.stringify({ event: 'command', func: 'playVideo', args: [] }), 'https://www.youtube.com');
      }
      control.setAttribute('aria-pressed', isSoundOn ? 'false' : 'true');
      const nextLabel = isSoundOn ? control.dataset.soundOn : control.dataset.soundOff;
      control.setAttribute('aria-label', nextLabel);
      if (label) label.textContent = nextLabel;
    });
  });
};

initVideoSoundControls();
document.addEventListener('shopify:section:load', (event) => initVideoSoundControls(event.target));

const initCartDrawer = (scope = document) => {
  const drawer = document.querySelector('[data-cart-drawer]');
  if (!drawer) return;
  scope.querySelectorAll('[data-cart-open]').forEach((button) => {
    if (button.dataset.cartReady === 'true') return;
    button.dataset.cartReady = 'true';
    button.addEventListener('click', () => drawer.showModal());
  });
  drawer.querySelectorAll('[data-cart-close]').forEach((button) => {
    if (button.dataset.cartReady === 'true') return;
    button.dataset.cartReady = 'true';
    button.addEventListener('click', () => drawer.close());
  });
  if (drawer.dataset.dismissReady !== 'true') {
    drawer.dataset.dismissReady = 'true';
    drawer.addEventListener('click', (event) => {
      if (event.target === drawer) drawer.close();
    });
  }
  if (sessionStorage.getItem('tbj-open-cart') === 'true') {
    sessionStorage.removeItem('tbj-open-cart');
    drawer.showModal();
  }
};

const initAjaxProductForms = (scope = document) => {
  scope.querySelectorAll('form[action*="/cart/add"]').forEach((form) => {
    if (form.dataset.ajaxCartReady === 'true') return;
    form.dataset.ajaxCartReady = 'true';
    form.addEventListener('submit', async (event) => {
      if (event.submitter && event.submitter.name === 'checkout') return;
      event.preventDefault();
      const submit = form.querySelector('[type="submit"]');
      if (submit) submit.disabled = true;
      try {
        const response = await fetch(window.Shopify.routes.root + 'cart/add.js', {
          method: 'POST',
          headers: { Accept: 'application/json' },
          body: new FormData(form)
        });
        if (!response.ok) throw new Error('Cart add failed');
        const addedItem = await response.json();
        const quantity = Number(addedItem.quantity || 1);
        const price = Number(addedItem.final_price || addedItem.price || 0) / 100;
        dispatchTBJAnalytics('add_to_cart', {
          ecommerce: {
            currency: (window.TBJGoogleTags && window.TBJGoogleTags.currency) || 'USD',
            value: price * quantity,
            items: [{
              item_id: String(addedItem.variant_id || addedItem.id || ''),
              item_name: addedItem.product_title || addedItem.title || '',
              item_variant: addedItem.variant_title || '',
              item_brand: addedItem.vendor || '',
              price,
              quantity
            }]
          }
        }, () => {
          sessionStorage.setItem('tbj-open-cart', 'true');
          window.location.reload();
        });
      } catch (error) {
        form.submit();
      } finally {
        if (submit) submit.disabled = false;
      }
    });
  });
};

const normalizeTBJCartItems = () => {
  const cart = window.TBJAnalyticsContext && window.TBJAnalyticsContext.cart;
  if (!cart || !Array.isArray(cart.items)) return [];
  return cart.items.map((item) => ({
    item_id: String(item.item_id || ''),
    item_name: item.item_name || '',
    item_variant: item.item_variant || '',
    item_brand: item.item_brand || '',
    price: Number(item.price_cents || 0) / 100,
    quantity: Number(item.quantity || 1)
  }));
};

const initCheckoutTracking = (scope = document) => {
  scope.querySelectorAll('form[action*="/cart"]').forEach((form) => {
    if (form.dataset.checkoutTrackingReady === 'true') return;
    form.dataset.checkoutTrackingReady = 'true';
    form.addEventListener('submit', (event) => {
      const submitter = event.submitter;
      if (!submitter || submitter.name !== 'checkout') return;
      event.preventDefault();
      if (form.dataset.checkoutTrackingSending === 'true') return;
      form.dataset.checkoutTrackingSending = 'true';
      const context = window.TBJAnalyticsContext || {};
      const cart = context.cart || {};
      dispatchTBJAnalytics('begin_checkout', {
        ecommerce: {
          currency: context.currency || 'USD',
          value: Number(cart.value || 0) / 100,
          items: normalizeTBJCartItems()
        }
      }, () => form.submit());
    });
  });
};

initCartDrawer();
initAjaxProductForms();
initCheckoutTracking();
document.addEventListener('shopify:section:load', (event) => {
  initCartDrawer(event.target);
  initAjaxProductForms(event.target);
  initCheckoutTracking(event.target);
});

document.addEventListener('click', (event) => {
  const link = event.target.closest('a[href]');
  if (!link) return;
  let url;
  try {
    url = new URL(link.href, window.location.href);
  } catch (error) {
    return;
  }
  if (!/^https?:$/.test(url.protocol) || url.origin === window.location.origin) return;

  const host = url.hostname.toLowerCase();
  let channel = 'external';
  if (host.includes('amazon.')) channel = 'amazon';
  else if (host.includes('tiktok.')) channel = url.pathname.toLowerCase().includes('shop') ? 'tiktok_shop' : 'tiktok';
  else if (host.includes('7krave.com')) channel = '7krave';
  else if (host.includes('apps.apple.com')) channel = 'apple_app_store';
  else if (host.includes('play.google.com')) channel = 'google_play';
  else if (host.includes('chat.whatsapp.com')) channel = 'whatsapp_community';
  else if (host.includes('youtube.com') || host.includes('youtu.be')) channel = 'youtube';
  else if (host.includes('linkedin.com')) channel = 'linkedin';
  else if (host.includes('instagram.com')) channel = 'instagram';
  else if (host.includes('facebook.com')) channel = 'facebook';

  dispatchTBJAnalytics('outbound_channel_click', {
    channel,
    link_url: url.href,
    link_text: (link.textContent || '').trim().slice(0, 120)
  });
});
